import LogRocketInternal from 'logrocket'

import { environment } from 'utils/constants'

export const initialize = () => {
  if (environment.isProd) LogRocketInternal.init('d3iq51/upswing-fitness')
}

export type LR = typeof LogRocketInternal

export const LogRocket: LR = LogRocketInternal
